import { useMemo } from "react";
import { TabProps } from "@services/api/tab/tab.types";
import { ParsedFilter, parseFilter } from "@src/app/filters/Filters";
import { getLocalizedText } from "@src/app/i18n/LocalizedText";
import { useMainTabs } from "./useMainTabs";

type UseActiveMainTabReturn = {
  activeMainTab: TabProps | undefined;
  activeMainTabName?: string;
  activeMainTabParsedFilter?: ParsedFilter;
};

export function useActiveMainTab(): UseActiveMainTabReturn {
  const parentTabs = useMainTabs();

  return useMemo(() => {
    const activeMainTab = parentTabs?.find((tab) => tab.isActiveMain);
    const activeMainTabName = getLocalizedText(
      activeMainTab?.labels,
      activeMainTab?.name
    );

    const parsedFilter = parseFilter(activeMainTab?.filter);
    return {
      activeMainTab,
      activeMainTabName,
      activeMainTabParsedFilter: parsedFilter
    };
  }, [parentTabs]);
}
